module.exports = __webpack_public_path__ + "media/images/youtube-icon-c683d9c94dc3d71865fa94d09b1d8c1e.svg";